import { isNullOrUndefined } from 'util';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { delay } from 'q';
import * as d3 from 'd3';
import { ActivatedRoute, Params, Router } from '@angular/router';
// import { RadarService } from '../../side-bar/nowcast-dashboard/radar/radar.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { NowcastDataServiceService } from '../../side-bar/nowcast-dashboard/nowcast-data-service.service';
import { HeatIndexDataService } from '../../side-bar/heat-index/heat-index-data.service';

@Component({
  selector: 'app-play-progress-bar',
  templateUrl: './play-progress-bar.component.html',
  styleUrls: ['./play-progress-bar.component.scss']
})
export class PlayProgressBarComponent implements OnInit, OnDestroy, OnChanges {

  styleObjforBottomBar: {};
  playpause: boolean;
  state = 'stop';
  playWidth: any = 3;
  startIndex: any = 0;
  bottomBarMenuSelectedIndex = 0;
  oldPlayButton: any;
  playBetweenIndex: any;
  forecastLengthSubscription: any;
  forecastLength: any;
  currentIndex: any = 0;
  urlparams: any;
  routeSections: string[] = [];
  application: string;
  // radarSource : string;
  selectedSource: string;
  subApplication: string;
  queryParams: any;
  // updateVisibility: any;

  constructor(private route: ActivatedRoute, private router: Router, private utils: UtilsService, private heatIndexService: HeatIndexDataService) {
    this.forecastLengthSubscription = this.route.params.subscribe(routeParams => {
      const forecastLength = routeParams.time;
      if (forecastLength != this.forecastLength) {
        this.forecastLength = routeParams.time;
        this.bottomBarMenuSelectedIndex = 0;
        this.styleObjforBottomBar = { width: 0 };
      }
    });
    this.styleObjforBottomBar = { width: 0 };
  }

  @Input() playButtonDisable: boolean;
  @Input() labelStrings: any;
  @Input() playPosition: number;
  @Input() activeSideMenu: any;
  @Input() playFastSlow: boolean;
  @Output() groupSelected = new EventEmitter<any>();
  ngOnInit() {
    this.application = this.router.url.split('/')[1];
    this.subApplication = this.router.url.split('/')[2]
    // this.radarSourceService.radarSource.subscribe(data => {
    //   this.radarSource = data;
    // });
    // this.utils.getRadarSourceData().subscribe((source) => {
    //   this.selectedSource = source;
    //   if(this.application == 'nowcastweather' && this.selectedSource != 'RICKEN'){
    //     this.bottomBarMenuSelectedIndex = 5;
    //     this.startIndex = 5;
    //     this.currentIndex = 5;
    //     this.playBetweenIndex = 5;
    //   } else {
    //     this.bottomBarMenuSelectedIndex = 0;
    //     this.startIndex = 0;
    //     this.currentIndex = 0;
    //     this.playBetweenIndex = 0;
    //   }
      // this.updateVisibility();
      // console.log('isObservedWeather:', this.isObservedWeather);
      //       console.log('shouldDisplayObservedRainfall:', this.shouldDisplayObservedRainfall());
      //       console.log('shouldDisplayForecastRainfall:', this.shouldDisplayForecastRainfall());
    // });
    // this.utils.getNowcastView().subscribe(view => {
    //   if(this.application == "nowcastweather" && view && this.selectedSource != 'RICKEN') {
    //     this.bottomBarMenuSelectedIndex = 5;
    //     this.startIndex = 5;
    //     this.currentIndex = 5;
    //     this.playBetweenIndex = 5;
    //   } else {
    //     this.bottomBarMenuSelectedIndex = 0;
    //     this.startIndex = 0;
    //     this.currentIndex = 0;
    //     this.playBetweenIndex = 0;
    //   }
    // });
        this.route.queryParamMap.subscribe(async (params: Params) => {
          this.queryParams = {};
          for (const param in params) {
            if (params.hasOwnProperty(param)) {
              this.queryParams = params[param];
            }
          }
          if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
            this.selectedSource = this.queryParams['source'];
          }
        })
  }
  ngOnDestroy() {
    this.forecastLengthSubscription.unsubscribe();
  }

  ngOnChanges(change: SimpleChanges) {
    if (!isNullOrUndefined(change.playPosition) && !isNullOrUndefined(change.playPosition.currentValue)) {
      setTimeout(() => this.changeStartIndex(change.playPosition.currentValue), 10);
    }
    if (( (this.router.url.split('/')[2] === 'cloudcover' || this.router.url.split('/')[2] === 'cloudtemperature') )
    || (this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
      setTimeout(() => this.changeStartIndex(this.labelStrings.length - 1), 100);
    }
    this.urlparams = this.getCurrentUrlParams();

    if (this.playButtonDisable == true) {
      this.oldPlayButton = this.playButtonDisable;
      this.styleObjforBottomBar = { width: 0 };
      this.state = 'stop';
      this.playWidth = 3;
    let index:any = this.heatIndexService.setBlockNumber();
      if(this.subApplication == 'heatwave'){
        this.bottomBarMenuSelectedIndex = index;
        this.startIndex = index;
        this.currentIndex = index;
        this.playBetweenIndex = index;
      } else if ((this.subApplication == 'nowcast' || this.subApplication == 'kolkata-nowcast' || (this.subApplication == 'abg-site' && this.queryParams['dashboardName'] == 'nowcast')) && this.selectedSource != 'RICKEN') {
        this.bottomBarMenuSelectedIndex = this.selectedSource != 'EUMETSAT' ? 5 : 7;
        this.startIndex = this.selectedSource != 'EUMETSAT' ? 5 : 7;
        this.currentIndex = this.selectedSource != 'EUMETSAT' ? 5 : 7;
        this.playBetweenIndex = this.selectedSource != 'EUMETSAT' ? 5 : 7;
      } else {
        this.bottomBarMenuSelectedIndex = 0;
        this.startIndex = 0;
        this.currentIndex = 0;
        this.playBetweenIndex = 0;
      }
      this.changebutton();
    }
    if (this.labelStrings.length > 0) {
      const i = this.bottomBarMenuSelectedIndex;
      const width = ((i) * (100 / (this.labelStrings.length - 1)));
      if ((this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
        this.styleObjforBottomBar = {};
      } else {
        this.styleObjforBottomBar = { width: width.toString() + '%' };
      }
    }
  }
  get showWeatherLabel(): boolean {
    return this.labelStrings.length > 0;
  }

  get isObservedWeather(): boolean {
    return this.selectedSource == 'EUMETSAT' ? this.bottomBarMenuSelectedIndex < 8 : this.bottomBarMenuSelectedIndex < 6;
  }
  shouldDisplayObservedRainfall(): boolean {
    const result = this.isObservedWeather && this.selectedSource !== 'RICKEN';
    // console.log('shouldDisplayObservedRainfall:', result);
    return result;
}

shouldDisplayForecastRainfall(): boolean {
  const result = !this.isObservedWeather && (
      this.selectedSource === 'RADAR' ||
      this.selectedSource === 'IMD RADAR' ||
      this.selectedSource === 'RADAR+CTT' ||
      this.selectedSource === 'IMD_LONG_RANGE' ||
      this.selectedSource === 'EUMETSAT'
  );
  // console.log('shouldDisplayForecastRainfall:', result);
  return result;
}

  reverseThreeDays() {
    if (this.state === 'pause') {
      this.state = 'play';
      this.animateProgressBar();
    } else {
      this.state = 'pause';
    }
    this.changeReverseButton();
    d3.select('#button_play i').attr('class', 'fa fa-play')
  }

  async animateProgressBar() {
    let newIndex = this.startIndex - 1;
    if (newIndex < 0) {
      newIndex = 0;
    }
    const animateStep = async () => {
      this.startIndex = newIndex;
      this.currentIndex = newIndex;
      const width = ((newIndex) * (100 / (this.labelStrings.length - 1)));
      this.styleObjforBottomBar = { width: width.toString() + '%' };
      this.bottomBarMenuSelectedIndex = newIndex
      if (this.labelStrings[newIndex]) {
        this.groupSelected.emit(this.labelStrings[newIndex]['groupName']);
      }
      await delay(1000);
      if (newIndex > 0 && this.state === 'play') {
        newIndex--;
        await animateStep();
      } else if (newIndex === 0 && this.state === 'play') {
        let index:any = this.labelStrings.length-1//this.heatIndexService.setBlockNumber();
        newIndex = index;
        await animateStep();
      }
    };
    if (this.state === 'play') {
      animateStep();
    }
  }

  async animate() {
    // console.log("hello");
    this.changebutton();
    this.playpause = !this.playpause;
    /*This if written for the condition when width is 100 and user clicks play button*/
    if (this.state == 'play' || this.state == 'resume') {
      this.state = 'pause';
      this.changebutton();
      return;
    }

    if (this.state == 'stop') {
      const width = 3;
      this.playWidth = 12 / (this.labelStrings.length - 1);
      if ((this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
        this.styleObjforBottomBar = {};
      } else {
        this.styleObjforBottomBar = { width: width.toString() };
      }
      this.groupSelected.emit(this.labelStrings[0]['groupName']);
      this.bottomBarMenuSelectedIndex = 3;
      this.state = 'play';
      this.changebutton();
    } else if (this.state == 'pause') {
      this.state = 'play';
      this.changebutton();
    }
    // console.log(this.mapDataForAllTs.length);
    for (let index = this.startIndex; index <= this.labelStrings.length; index++) {
      this.currentIndex = index;
      if ((this.state === 'play' || this.state === 'resume')) {
        // let width = this.playWidth;
        if (index >= this.labelStrings.length) {
          this.startIndex = 3;
          this.currentIndex = 3;
          index = -1;
          this.playWidth = 3;
          this.playBetweenIndex = 3;
          const width = 3;
          if ( (this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
            this.styleObjforBottomBar = {};
          } else {
            this.styleObjforBottomBar = { width: width.toString() + '%' };
          }
          await delay(1000);
          continue;
        }
        this.groupSelected.emit(this.labelStrings[index]['groupName']);
        this.bottomBarMenuSelectedIndex = index;
        let i = this.playBetweenIndex;
        while (i <= 30) {
          if (this.state === 'play' || this.state === 'resume') {
            const width = ((index) * (100 / (this.labelStrings.length - 1))) + (i * ((100 / (this.labelStrings.length - 1)) / 30)) + (2.5 - ((this.labelStrings.length - 5) / 12));
            const num = 6;
            if ( (this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
              this.styleObjforBottomBar = {};
            } else {
              this.styleObjforBottomBar = { width: width.toString() + '%', transition: num.toString() + 's' + 'ease' };
            }
            if (( 
              (this.router.url.split('/')[2] === 'cloudcover' ||
              this.router.url.split('/')[2] === 'cloudtemperature')) || (this.router.url.split('/')[1] === 'nowcastweather' && this.playFastSlow == true)) {
              await delay(5);
            } else {
              await delay(50);
            }
          } else {
            this.startIndex = index;
            this.currentIndex = index;
            this.playBetweenIndex = i;
            return;
          }
          i++;
          if (index != this.currentIndex) {
            i = -10;
            index = this.currentIndex;
          }
        }
        this.playBetweenIndex = 3;
        if (index === this.labelStrings.length) {
          this.startIndex = 3;
          this.currentIndex = 3;
          index = -1;
          this.playWidth = 3;
          this.playBetweenIndex = 3;
          const width = 3;
          if (
             (this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
            this.styleObjforBottomBar = {};
          } else {
            this.styleObjforBottomBar = { width: width.toString() + '%' };
          }
          await delay(1000);
          continue;
          // this.changebutton();
        }
        await delay(100);
      } else {
        if (index < this.labelStrings.length) {
          this.startIndex = index;
          this.currentIndex = index;
          this.state = 'pause';
        } else {
          this.startIndex = 1;
          this.currentIndex = 1;
          this.state = 'pause';
        }
        break;
      }
    }

  }

  changeStartIndex(i) {
    if (i == this.currentIndex) {
      return;
    }
    this.startIndex = i;
    this.currentIndex = i;
    this.bottomBarMenuSelectedIndex = i;
    this.playBetweenIndex = i;
    const width = ((i) * (100 / (this.labelStrings.length - 1)));
    if (
       (this.router.url.split('/')[1] === 'cyclone' && this.playFastSlow == true)) {
      this.styleObjforBottomBar = {};
    } else {
      this.styleObjforBottomBar = { width: width.toString() + '%' };
    }
    if (this.labelStrings[i]) {
      this.groupSelected.emit(this.labelStrings[i]['groupName']);
    }
  }

  changebutton() {
    if (this.state == 'play' || this.state == 'resume') {
      d3.select('#button_play i').attr('class', 'fa fa-pause');
      d3.select('#button_play_reverse i').attr('class', 'fa fa-play icon-rotate-left');
    } else {
      d3.select('#button_play i').attr('class', 'fa fa-play');
    }

  }

  changeReverseButton() {    
    if (this.state == 'play' || this.state == 'resume') {
      d3.select('#button_play_reverse i').attr('class', 'fa fa-pause');
    } else {
      d3.select('#button_play_reverse i').attr('class', 'fa fa-play icon-rotate-left');
    }

  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return '';
    } else {
      return this.labelStrings[i]['label']['label'];
    }
  }

  getToolTipValue(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return '';
    } else {
      return this.labelStrings[i]['label']['toolTip'];
    }
  }

  getCurrentUrlParams() {
    const obj = this.route.snapshot.params;
    this.routeSections = this.router.url.split('/');
    if (obj == null || obj == undefined) { return obj; }
    if (this.routeSections[1] === 'extremeweather' && this.routeSections[2] === 'rainfall' &&
      this.routeSections[3] === '24' ) {
      if (Object.keys(this.labelStrings).length > 0) {
        const i = Object.keys(this.labelStrings).length - 1;
        this.startIndex = i;
        this.currentIndex = i;
        this.bottomBarMenuSelectedIndex = i;
        this.playBetweenIndex = 3;
        this.groupSelected.emit(this.labelStrings[i]['groupName']);
      }
    }
    const objectConfig = {};
    for (const key in obj) {
      objectConfig[key] = obj[key];
    }

    return objectConfig;
  }

  // showtooltipval() {
  //   if (this.urlparams['time'] || ( this.routeSections[1] === 'cyclone')) {
  //     return true;
  //   }
  //   return false;
  // }

  showtooltipval() {
    if (this.queryParams['forecastLength'] || ( this.routeSections[1] === 'cyclone')) {
      return true;
    }
    return false;
  }

  // changebutton() {
  //   console.log(this.state);
  //   if (this.state === 'stop') {
  //     this.state = 'play';
  //     let button = d3.select('#button_play').classed('btn-success', true);
  //     button.select('i').attr('class', 'fa fa-play');
  //   } else if (this.state == 'play' || this.state == 'resume') {
  //     this.state = 'pause';
  //     d3.select('#button_play i').attr('class', 'fa fa-play');
  //   } else if (this.state == 'pause') {
  //     this.state = 'resume';
  //     d3.select('#button_play i').attr('class', 'fa fa-pause');
  //   } else if(this.state === 'end'){
  //     this.state = 'stop';
  //     d3.select('#button_play i').attr('class', 'fa fa-play');
  //   }

  //   console.log(this.state);
  // }

}
